import React from 'react';
import DsLabel from './index';

const LabelWarning = ({ children }) => (
        <DsLabel icon="alert" className="text-base" iconClassName="text-xl text-status-orange">
          {children}
        </DsLabel>
);

export default LabelWarning;
